<template>

    <button type="button" class="close" :class="classes" :aria-label="ariaLabel || $t('labels.close')">
        <i class="fas fa-times" aria-hidden="true"></i>
    </button>

</template>

<style scoped lang="scss">

    .close {
        appearance: none;
        background: none;
        border: none;
        color: $color-text;
        cursor: pointer;
        display: grid;
        font-size: 16px;
        height: 40px;
        line-height: 0;
        margin: 0;
        opacity: 0.5;
        padding: 0;
        position: relative;
        place-items: center;
        right: 0;
        text-align: center;
        text-decoration: none;
        top: 0;
        transition: opacity .3s;
        user-select: none;
        width: 40px;
        z-index: 1;
        &:hover {
            background: none;
            opacity: 1 !important;
        }
        &.close-info {
            color: $color-text;
        }
        &.close-danger {
            color: $color-danger;
        }
        &.close-success {
            color: $color-success;
        }
    }

</style>

<script>

export default {

    props: {
        type: {
            type: String,
        },
        ariaLabel: {
            type: String,
            default: null,
        },
    },

    computed: {

        classes() {
            return {
                'close-info': this.type === 'info',
                'close-danger': this.type === 'danger',
                'close-success': this.type === 'success',
            };
        },

    },

}

</script>